import { getImageUrlByDimension } from '@yme/utils/common';
import { MOBILE_KEY } from '@yme/utils/constants';
export function buildImageProps(image) {
    return image
        ? {
            src: getImageUrlByDimension({
                src: image?.url || '',
                dimension: MOBILE_KEY,
            }),
            fallbackSrc: image?.url || '',
        }
        : {
            src: '',
            fallbackSrc: '',
        };
}
